import * as React from 'react';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { Accordion, AccordionSummary, Typography, AccordionDetails, createStyles, makeStyles, Theme } from '@material-ui/core';
import ReactMarkdown from 'react-markdown';
import { renderers } from '../../markdownRenderers';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        markdownBody: {
          "& > img": {
            maxWidth: "100%"
          },
          "& > p > img": {
            maxWidth: "100%"
          },
        },
    }),
);

type AccordionProps = {
    title: string| JSX.Element
    answer: string;
}

type Props = {
    items: AccordionProps[];
    className?: string;
}

const StyledAccordion: React.FC<Props> = ({items, className}) => {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState<string | false>(false);

  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };

  return (
    <div className={className}>
      {items.map(item => <Accordion expanded={expanded === `${item.title}`} onChange={handleChange(`${item.title}`)}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
            <Typography variant="h4">{item.title}</Typography>
        </AccordionSummary>
        <AccordionDetails>
            <Typography className={classes.markdownBody}>
              <ReactMarkdown linkTarget="_blank" className={classes.markdownBody}>
                {item.answer}
              </ReactMarkdown>
            </Typography>
        </AccordionDetails>
      </Accordion>)}
    </div>
  );
}

export default StyledAccordion